import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterEnumRadioBoxHandler from "./IDataFilterEnumRadioBoxHandler";
import IDataFilterEnumValue from "../enumCheckBox/IDataFilterEnumValue";

export default class DataFilterEnumRadioBoxHandler
  implements IDataFilterEnumRadioBoxHandler
{
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const storeValue = urlParams.get(descriptor.name);

    const descriptorValue = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.key === storeValue
    );
    if (!descriptorValue) return;

    // Přenastavím všechny hodnoty na false
    (descriptor.value as IDataFilterEnumValue[]).forEach((value) => {
      value.value = false;
    });

    // Nastavím vybranou hodnotu
    descriptorValue.value = true;
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const enumValue = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.value
    );
    if (enumValue) {
      urlParams.set(descriptor.name, enumValue.key);
    } else {
      urlParams.delete(descriptor.name)
    }
  }
}